module.exports = __webpack_public_path__ + "img/Boy_020012.9daec997.png";